import { render } from "./StichingMeasurment.vue?vue&type=template&id=c81e4066"
import script from "./StichingMeasurment.vue?vue&type=script&lang=js"
export * from "./StichingMeasurment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__